import Api from "../../../shared/api/api";

const STORAGE_KEY = "fourHTestId";

const getStoredTestId = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const storedValue =
      window.localStorage.getItem(
        STORAGE_KEY
      );

    if (!storedValue) {
      return null;
    }

    const parsedValue = Number(storedValue);

    return Number.isFinite(parsedValue) &&
      parsedValue > 0
      ? parsedValue
      : null;
  } catch (error) {
    console.error(
      "Unable to read stored FourH test ID:",
      error
    );

    return null;
  }
};

const storeTestId = (testId) => {
  if (
    typeof window === "undefined" ||
    !testId
  ) {
    return;
  }

  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      String(testId)
    );
  } catch (error) {
    console.error(
      "Unable to store FourH test ID:",
      error
    );
  }
};

export const clearStoredTestId = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(
      STORAGE_KEY
    );
  } catch (error) {
    console.error(
      "Unable to clear stored FourH test ID:",
      error
    );
  }
};

export const getLatestTest = async () => {
  const tests = await Api.getAll("test");

  if (tests?.error) {
    throw new Error(tests.error);
  }

  if (
    !Array.isArray(tests) ||
    tests.length === 0
  ) {
    return null;
  }

  return [...tests].sort(
    (firstTest, secondTest) => {
      const firstId =
        Number(
          firstTest.id ??
            firstTest.test_id ??
            0
        ) || 0;

      const secondId =
        Number(
          secondTest.id ??
            secondTest.test_id ??
            0
        ) || 0;

      return secondId - firstId;
    }
  )[0];
};

export const getLatestTestId = async () => {
  const latestTest = await getLatestTest();

  if (!latestTest) {
    return null;
  }

  const testId = Number(
    latestTest.id ?? latestTest.test_id
  );

  return Number.isFinite(testId) &&
    testId > 0
    ? testId
    : null;
};

export const getStoredOrLatestTestId =
  async () => {
    const storedTestId =
      getStoredTestId();

    if (storedTestId) {
      return storedTestId;
    }

    const latestTestId =
      await getLatestTestId();

    if (latestTestId) {
      storeTestId(latestTestId);
    }

    return latestTestId;
  };

export const setCurrentTestId = (
  testId
) => {
  const normalizedTestId = Number(testId);

  if (
    !Number.isFinite(normalizedTestId) ||
    normalizedTestId <= 0
  ) {
    throw new Error(
      "A valid FourH test ID is required."
    );
  }

  storeTestId(normalizedTestId);

  return normalizedTestId;
};